import React from 'react';
import {FormField, FormSection, FormActions} from '../../../Presentation/components/common';
import {useFormState, CommonValidationRules, createFieldProps} from '../../../Presentation/utils/formUtils';

interface TypeFormProps {
  initialName?: string;
  initialDescription?: string;
  onSubmit: (data: { name: string; description?: string }) => void;
  onCancel: () => void;
  submitting?: boolean;
}

const TypeForm: React.FC<TypeFormProps> = ({initialName = '', initialDescription = '', onSubmit, onCancel, submitting}) => {
  const [formState, formActions] = useFormState(
    {
      name: initialName,
      description: initialDescription
    },
    {
      name: CommonValidationRules.required('اسم النوع'),
      description: {
        maxLength: 500,
        customValidator: (value: string) => {
          if (value && value.length > 500) {
            return 'الوصف يجب أن يكون أقل من 500 حرف';
          }
          return null;
        }
      }
    }
  );

  const handleSubmit = async (data: { name: string; description?: string }) => {
    onSubmit({name: data.name.trim(), description: data.description?.trim() || undefined});
  };

  return (
    <FormSection title="بيانات النوع" description="أدخل بيانات النوع الجديد">
      <div className="space-y-4">
        <FormField
          type="text"
          label="اسم النوع"
          placeholder="أدخل اسم النوع"
          {...createFieldProps('name', formState, formActions)}
          disabled={submitting}
          autoFocus
        />

        <FormField
          type="textarea"
          label="الوصف (اختياري)"
          placeholder="أدخل وصف النوع"
          rows={3}
          {...createFieldProps('description', formState, formActions)}
          disabled={submitting}
        />
      </div>

      <FormActions
        onSubmit={() => formActions.submit(handleSubmit)}
        onCancel={onCancel}
        submitLabel="حفظ"
        cancelLabel="إلغاء"
        isLoading={formState.isSubmitting || submitting}
        disabled={!formState.isValid}
      />
    </FormSection>
  );
};

export default TypeForm;
